import React from 'react'

// bootstrap
import {
    Col
} from 'react-bootstrap'

// fields
import BlogDetails from './FormBlogs__Details'
import BlogMeta from './FormBlogs__Meta'
import BlogDescription from './FormBlogs__Description'

export default function BlogsFormContentView(props) {
    const { formik, emailEvents, getHTML_editorResult } = props

    return (
        <React.Fragment>
            {/* app card */}
            <div className="app-card mb-3 mb-lg-4">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize">Blog Details</p>
                </div>
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                    <Col xs={12} md={9} lg={6} className="px-0">
                        <BlogDetails
                            formik={formik}
                            emailEvents={emailEvents}
                        />
                    </Col>
                </div>
            </div>

            {/* app card */}
            <div className="app-card mb-3 mb-lg-4">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize">Blog Content</p>
                </div>
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20">
                    <Col xs={12} md={9} lg={10} className="px-0">
                        <BlogDescription
                            formik={formik}
                            getResult={getHTML_editorResult}
                        />
                    </Col>
                </div>
            </div>

            {/* app card */}
            <div className="app-card mb-3 mb-lg-4">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize">Meta Detail</p>
                </div>
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20">
                    <Col xs={12} md={9} lg={10} className="px-0">
                        <BlogMeta
                            formik={formik}                            
                        />
                    </Col>
                </div>
            </div>
        </React.Fragment>
    )
}
